export enum FormID {
  TRUCK_JOURNEY = 1,
  LIFT_ON = 2,
  GATE_IN = 3,
  WEIGHBRIDGE_ENTRY = 4,
  LOAD_PRODUCT = 5,
  WEIGHBRIDGE_EXIT = 6,
  GATE_OUT = 7,
  RAILHEAD_EIR = 8,
  EIR = 8,
  LIFT_OFF = 10,
  REHEAT_TANK = 11,
  UNLOAD_PRODUCT = 12,
  RAILHEAD_BOL = 13,
  BOL = 13,
  ON_LOADING = 14,
  OFF_LOADING = 15,
  VESSEL_ARRIVAL = 16,
  VESSEL_DEPARTURE = 17,
  CARGO_COLLECTION = 18,
  CARGO_DELIVERY = 19,
  DGD = 20
}
